import React from "react";
import "./catalogue-review.scss";
import { ReviewStars } from "./ReviewStars";
import { ReviewData } from "../../../common/interfaces";

export const CatalogueReview: React.FC<ReviewData> = ({
  date,
  customer,
  text,
  title,
  product,
  url,
  rating,
  location
}) => {
  return (
    <div className="c-reviews-page-review">
      <div className="c-reviews-page-review__meta-reviewer">
        <div>
          <ReviewStars rating={rating} />
          <span className="c-reviews-page-review__customer_location">
            {customer} {location && `, ${location}`}
          </span>
        </div>
        <span className="c-reviews-page-review__date">{date}</span>
      </div>
      <div className="c-reviews-page-review__text">
        <div className="c-reviews-page-review__title">{title}</div>
        {text}
        <br />
        <a href={url}>Hired {product} </a>
      </div>
    </div>
  );
};
